export default class IndexSubview {
  constructor(parent) {
      this.parent = parent;      
      this.el = parent.el.querySelector('.index-subview'); 
      this.router = parent.router;
      this.myCars = this.el.querySelector('.my-cars');
  }

  toggleMyCar(show) {
    show ? this.myCars.classList.remove('hide') : this.myCars.classList.add('hide');
  }

  show() {
      this.el.classList.remove('hide');
  }

  hide() {
      this.el.classList.add('hide');
  }
}
